import { useTranslation } from 'react-i18next';
import { colors } from 'components/styles/variables';
import { DaysOfWeek, DealerDayHours, DealerHours } from 'lib/models/DealerHours';

interface DayProps {
  hours: DealerHours['todayHours'];
  isOpen: boolean;
}

function Day({ hours, isOpen }: DayProps): JSX.Element | null {
  const { t } = useTranslation();

  return !isOpen ? (
    <div>{t('dealerPages.closed')}</div>
  ) : (
    <div>
      <time>{hours.open}</time>
      &nbsp;
      {'-'}
      &nbsp;
      <time>{hours.close}</time>
    </div>
  );
}

interface WeekRowProps {
  day: DaysOfWeek;
  hours: DealerDayHours;
  isToday: boolean;
}

function WeekRow({ day, hours, isToday }: WeekRowProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <tr className="hour-row">
      <td className="day">{t(`dealerPages.${day.toLowerCase()}`)}</td>
      <td className={`hours ${isToday && 'today'}`} data-testid={`day-${day}`}>
        {hours && <Day hours={hours} isOpen={!!hours.isOpen} />}
        <i className={`dot ${isToday && 'filled'}`} />
      </td>
      <style jsx>{`
        .hours {
          display: flex;
          line-height: 20px;
          font-weight: 500;
          font-size: 14px;
          color: ${colors.G4};
        }

        .today {
          font-weight: bold;
          font-size: 14px;
          color: ${colors.BLACK};
        }

        .day {
          font-size: 14px;
          font-weight: bold;
          text-transform: uppercase;
          padding-right: 5px;
          color: ${colors.BLACK};
          padding-right: 12px;
        }

        .dot {
          margin-left: 7px;
          height: 7px;
          width: 7px;
          border-radius: 50%;
          display: block;
          align-self: center;
        }

        .dot.filled {
          background-color: ${colors.BLACK};
        }
      `}</style>
    </tr>
  );
}

export { Day, WeekRow };
